module.exports = __webpack_public_path__ + "img/logo-icon.64a09294.svg";